// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.usersFilterComponent {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
}

.users_filter_dropdown_div {
    display: flex;
    flex-direction: row;
    gap: 6px;
    align-items: center;
}

.users_filter_dropdown_div label {
    font-size: 13px;
    font-weight: 500;
    color: var(--text-secondary);
    white-space: nowrap;
}

.userFilterSelect,
.usersFilterComponent .custom-select {
    width: unset;
    padding: 6px 12px;
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    font-size: 13px;
    color: var(--text-primary);
    background-color: var(--bg-card);
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    outline: none;
    transition: all var(--transition-fast);
}

.userFilterSelect:focus,
.usersFilterComponent .custom-select:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 3px var(--primary-light);
}

/* Radio buttons as pill/chip selectors */
.usersFilterComponent div:has(> input[type="radio"]) {
    display: flex;
    align-items: center;
    gap: 0;
}

.usersFilterComponent input[type="radio"] {
    display: none;
}

.usersFilterComponent input[type="radio"] + label {
    padding: 5px 12px;
    border-radius: var(--radius-sm);
    font-size: 12px;
    font-weight: 500;
    color: var(--text-secondary);
    cursor: pointer;
    transition: all var(--transition-fast);
    white-space: nowrap;
    -webkit-user-select: none;
            user-select: none;
    border: 1px solid var(--border);
    background-color: var(--bg-card);
}

.usersFilterComponent input[type="radio"] + label:hover {
    color: var(--text-primary);
    border-color: var(--primary-50);
}

.usersFilterComponent input[type="radio"]:checked + label {
    background-color: var(--primary);
    color: white;
    border-color: var(--primary);
    box-shadow: var(--shadow-sm);
}

/* Gift filter */
.giftFilterComponent div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
}

.giftFilterComponent div div {
    display: flex;
    align-items: center;
}

.giftFilterComponent input[type="checkbox"] + label {
    margin-left: 5px;
    color: var(--text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/components/Filters/UsersFilter/userFilter.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;IAC/B,+BAA+B;IAC/B,eAAe;IACf,0BAA0B;IAC1B,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,aAAa;IACb,sCAAsC;AAC1C;;AAEA;;IAEI,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA,yCAAyC;AACzC;IACI,aAAa;IACb,mBAAmB;IACnB,MAAM;AACV;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,sCAAsC;IACtC,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;IACjB,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;AAChC","sourcesContent":[".usersFilterComponent {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.users_filter_dropdown_div {\n    display: flex;\n    flex-direction: row;\n    gap: 6px;\n    align-items: center;\n}\n\n.users_filter_dropdown_div label {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--text-secondary);\n    white-space: nowrap;\n}\n\n.userFilterSelect,\n.usersFilterComponent .custom-select {\n    width: unset;\n    padding: 6px 12px;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    font-size: 13px;\n    color: var(--text-primary);\n    background-color: var(--bg-card);\n    cursor: pointer;\n    appearance: none;\n    -webkit-appearance: none;\n    outline: none;\n    transition: all var(--transition-fast);\n}\n\n.userFilterSelect:focus,\n.usersFilterComponent .custom-select:focus {\n    border-color: var(--primary);\n    box-shadow: 0 0 0 3px var(--primary-light);\n}\n\n/* Radio buttons as pill/chip selectors */\n.usersFilterComponent div:has(> input[type=\"radio\"]) {\n    display: flex;\n    align-items: center;\n    gap: 0;\n}\n\n.usersFilterComponent input[type=\"radio\"] {\n    display: none;\n}\n\n.usersFilterComponent input[type=\"radio\"] + label {\n    padding: 5px 12px;\n    border-radius: var(--radius-sm);\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--text-secondary);\n    cursor: pointer;\n    transition: all var(--transition-fast);\n    white-space: nowrap;\n    user-select: none;\n    border: 1px solid var(--border);\n    background-color: var(--bg-card);\n}\n\n.usersFilterComponent input[type=\"radio\"] + label:hover {\n    color: var(--text-primary);\n    border-color: var(--primary-50);\n}\n\n.usersFilterComponent input[type=\"radio\"]:checked + label {\n    background-color: var(--primary);\n    color: white;\n    border-color: var(--primary);\n    box-shadow: var(--shadow-sm);\n}\n\n/* Gift filter */\n.giftFilterComponent div {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n}\n\n.giftFilterComponent div div {\n    display: flex;\n    align-items: center;\n}\n\n.giftFilterComponent input[type=\"checkbox\"] + label {\n    margin-left: 5px;\n    color: var(--text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
